import { render } from "./app-header-help.vue?vue&type=template&id=c6574156&scoped=true&lang=true"
import script from "./app-header-help.vue?vue&type=script&lang=js"
export * from "./app-header-help.vue?vue&type=script&lang=js"

import "./app-header-help.vue?vue&type=style&index=0&id=c6574156&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6574156"]])

export default __exports__